<template>
  <div class="home">
    <header-view />
    <TimelineBanner />
    <TimelineWorkflow />
    <AccordianView />
    <GetQoute/>
    <footer-view />
  </div>
</template>

<script>


import HeaderView from "@/components/UiComponents/HeaderView.vue";
import AccordianView from "@/components/UiComponents/AccordianView.vue";
import FooterView from '@/components/UiComponents/FooterView.vue'
import TimelineBanner from "@/components/TimelineComponents/TimelineBanner.vue";
import TimelineWorkflow from "@/components/TimelineComponents/TimelineWorkflow.vue";
import GetQoute from "@/components/UiComponents/GetQoute.vue";
export default {
  name: 'WorkflowView',
  components: {
    HeaderView,
    TimelineBanner,
    TimelineWorkflow,
    AccordianView,
    GetQoute,
    FooterView,
  }
}
</script>
